import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils";

export type TokenPair = {
  access: string;
  refresh: string;
};

export const tokenPairSchema: Schema<TokenPair> = z.object({
  access: z.string(),
  refresh: z.string(),
});

export type RefreshedTokens = {
  access: string;
  refresh: string | undefined;
};

export const refreshedTokensSchema: Schema<RefreshedTokens> = z.object({
  access: z.string(),
  refresh: cz.optional(z.string()),
});
